'use client';

import { useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import { I18N_COOKIE_NAME, languages } from '~/lib/i18n/i18n.settings';

/**
 * Post-hydration language correction. Static pages ship with the default
 * language (the old server-side cookie read forced every route dynamic);
 * this reads the visitor's `lang` cookie on the client and switches i18next
 * if it differs. Non-default-language users see a brief default-language
 * flash per page load — the accepted cost of cacheable HTML.
 *
 * Server components inside dynamic (app) routes still resolve the cookie
 * server-side via withI18n — this only covers the client tree.
 */
export function LanguageSync() {
  const { i18n } = useTranslation();

  // Justified useEffect: document.cookie only exists client-side, and the
  // sync must run once after hydration.
  useEffect(() => {
    const cookieValue = document.cookie
      .split('; ')
      .find((part) => part.startsWith(`${I18N_COOKIE_NAME}=`))
      ?.split('=')[1];

    if (
      cookieValue &&
      languages.includes(cookieValue) &&
      i18n.language !== cookieValue
    ) {
      void i18n.changeLanguage(cookieValue);
    }
  }, [i18n]);

  return null;
}
